/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CompanyInputs */

const en_nav_company = /** @type {(inputs: Nav_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const es_nav_company = /** @type {(inputs: Nav_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Nav_CompanyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_company = /** @type {((inputs?: Nav_CompanyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CompanyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_company(inputs)
	return es_nav_company(inputs)
});